import { IDealsFilter } from 'modules/settings/submodules/clients/deals/store/models';
import { IStore } from 'store/configureStore';
import { selectDealsState } from 'modules/settings/submodules/clients/deals/store/selectors';

export const selectDealFilter = (state: IStore): IDealsFilter => selectDealsState(state).dealFilter;
